import { render, staticRenderFns } from "./BasicGauge.vue?vue&type=template&id=6d9b5145&"
import script from "./BasicGauge.vue?vue&type=script&lang=js&"
export * from "./BasicGauge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d9b5145')) {
      api.createRecord('6d9b5145', component.options)
    } else {
      api.reload('6d9b5145', component.options)
    }
    module.hot.accept("./BasicGauge.vue?vue&type=template&id=6d9b5145&", function () {
      api.rerender('6d9b5145', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Gauges/BasicGauge.vue"
export default component.exports